export default angular
    .module('toggle-switch', ['ng'])
    .name;


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-toggle-switch/main.module.js